import Vue from 'vue';
import BaseToastContainer from '@/components/base/BaseToastContainer.vue';

// Plugin de toasts: monta um único container no <body> e expõe uma API
// compatível com a do vue-toasted (`.success` / `.error` / `.warning` / `.info` / `.show`).
// Aceita HTML no conteúdo para manter compat com chamadas como
// $toasted.success('<b>Sucesso</b>&nbsp;&nbsp;Setor criado.').

let containerInstance = null;

function mountContainer() {
  if (containerInstance) return containerInstance;
  const Constructor = Vue.extend(BaseToastContainer);
  const el = document.createElement('div');
  document.body.appendChild(el);
  containerInstance = new Constructor().$mount(el);
  return containerInstance;
}

function normalize(input, opts) {
  // Aceita:
  //   show('texto'), show('texto', { ... }), show({ content, type, ... })
  if (typeof input === 'object' && input !== null) return { ...input, ...(opts || {}) };
  return { content: String(input ?? ''), ...(opts || {}) };
}

const api = {
  show(input, opts) {
    const c = mountContainer();
    return c.add({ ...normalize(input, opts), type: (opts && opts.type) || 'info' });
  },
  success(input, opts) {
    const c = mountContainer();
    return c.add({ ...normalize(input, opts), type: 'success' });
  },
  error(input, opts) {
    const c = mountContainer();
    return c.add({ ...normalize(input, opts), type: 'error' });
  },
  warning(input, opts) {
    const c = mountContainer();
    return c.add({ ...normalize(input, opts), type: 'warning' });
  },
  info(input, opts) {
    const c = mountContainer();
    return c.add({ ...normalize(input, opts), type: 'info' });
  },
  clear() { containerInstance && containerInstance.clear(); },
};

const ToastPlugin = {
  install(VueLocal) {
    // Garante container disponível assim que o plugin é instalado
    VueLocal.prototype.$toast   = api;
    VueLocal.prototype.$toasted = api; // alias retrocompatível com vue-toasted
    VueLocal.toasted            = api; // alias global usado em http.js
  },
};

export default ToastPlugin;
export { api as toast };
